import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';
/**
 * 示例模块
 */
export default {
  namespace: 'meetingDetail',
  state: {
    switchCheck: false,
    dataSource: [],
    meetingStatus: '',
  },
  reducers: {
    setDataSource(state, action) {
      return {
        ...state,
        dataSource: action.payload,
      };
    },
    setMeeting(state, action) {
      return {
        ...state,
        meetingStatus: action.payload,
      };
    },
  },
  effects: {
    *getDataSource(action, { put }) {
      const { meetingId } = action.payload;
      const res = yield fetch.get(API.MEETING_DATAILS + '?meetingId=' + meetingId);
      yield put({
        type: 'setDataSource',
        payload: res.data,
      });
    },
    *sendDataSource(action, { put }) {
      const { meetingId, callback = () => {} } = action.payload;
      const res = yield fetch.get(API.MEETING_ENROLL + '?meetingId=' + meetingId);
      // if(res.errorType  && res.errorType === "ERROR"){
      //   return Toast.fail(res.message);
      // }else{
      if (callback && typeof callback === 'function') {
        callback(res);
      }
      yield put({
        type: 'setMeeting',
        payload: res.data,
      });
      // }
    },
  },
};
